/**
 * Conteúdo da aba Leitura na fase PR (`pronto`).
 *
 * Iniciativa descricao-pr-persistida-fase-pronto: o backend persiste título e
 * descrição do Pull Request no momento do `create_pull_request` (colunas
 * `pr_title`/`pr_description` da atividade). Quando esse snapshot existe, a
 * Leitura da fase PR o exibe no lugar do texto livre do agente — determinístico
 * e fiel ao que foi publicado no provider. Sem snapshot (atividade anterior ao
 * deploy ou PR ainda não criado), retorna `null` e a Leitura mantém o fallback
 * atual (última mensagem/stream do agente).
 */
export interface PrReadingSource {
  prUrl?: string | null;
  prTitle?: string | null;
  prDescription?: string | null;
}

export const buildPrReadingContent = (
  activity: PrReadingSource,
): string | null => {
  const description = activity.prDescription?.trim();
  if (!description) {
    return null;
  }

  const sections: string[] = [];
  const title = activity.prTitle?.trim();
  if (title) {
    sections.push(`## ${title}`);
  }
  const url = activity.prUrl?.trim();
  if (url) {
    sections.push(`[Abrir Pull Request](${url})`);
  }
  sections.push(description);
  return sections.join('\n\n');
};
